import useSWR, { Fetcher, SWRConfiguration } from 'swr';
import { AxiosRequestConfig } from 'axios';
import { createAxiosInstance } from './axios';

const isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}\.\d*)(?:Z|([+-])([\d|:]*))?$/;
export const parseDate = (_thingBeingParsed: any, value: any) => {
  if (typeof value !== 'string') {
    return value;
  }
  if (isoDateRegex.exec(value)) {
    return new Date(value);
  }
  return value;
};

const axios = createAxiosInstance({
  baseURL: '/api/studykit',
  transformResponse: (data, headers) => {
    if (headers?.['content-type']?.includes('application/json')) {
      return JSON.parse(data, parseDate);
    }
    return data;
  },
});

export default function useRequest<TData>(
  request: AxiosRequestConfig<TData>,
  config?: SWRConfiguration<TData, unknown, Fetcher<TData>>,
) {
  const fetcher: Fetcher<TData> = () => axios.request<TData>(request).then((r) => r.data);
  return useSWR<TData>(request.url, fetcher, config);
}
